export default "__VITE_ASSET__BJLpwZ4o__"